import { createContext, RefObject } from 'react'

export const IonNavContext = createContext<RefObject<HTMLIonNavElement>|null>(null)
